import { logout } from '_api/login'
import { delCookie } from '_lib/utils/utils'
import { RTC_TYPE } from '@/common/constants/rtc'

export default {
  methods: {
    logout(from) {
      logout().finally(async () => {
        delCookie('heybox_id')
        delCookie('nickname')
        delCookie('avatar')
        delCookie('pkey')
        window.electronAPI?.logout()
        if (this.$rtc.RtcType === RTC_TYPE.VOLC_ELECTRON) {
          await this.$rtc.leave()
        } else if(process.env.IS_CLIENT && this.my_screen_sharing && this.$rtc.RtcType === RTC_TYPE.TRTC_ELECTRON) {
          await this.$rtc.stopPreviewScreenCapture()
        }
        setTimeout(() => {
          if (from) {
            window.location.href = from
          } else {
            if (process.env.IS_CLIENT) {
              window.location.href = 'file://' + location.pathname
            } else {
              window.location.href = location.origin + '/app'
            }
          }
        }, 100)
      })
    },
  },
}
